const SearchData = {
    width: ['WIDTH', 155, 165, 175, 185, 195, 205, 215, 225, 235, 245, 255, 265, 275, 285, 295, 305, 315, 31, 32, 33, 34, 35, 36, 37],
    profile: ['ASPECT RATIO', 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 10.5, 11.5, 12.5, 13.5],
    rim: ['SIZE', 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]
    // width: [155, 165, 175, 185, 195, 205, 215, 225, 235, 245, 255, 265, 275, 285, 295, 305, 315, 31, 32, 33, 34, 35, 36, 37],
    // profile: [25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 10.5, 11.5, 12.5, 13.5],
    // rim: [13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24]
}

export default SearchData